import Vue from 'vue';
import {ToastPlugin, ModalPlugin} from 'bootstrap-vue';
import VueCompositionAPI from '@vue/composition-api';

import {BootstrapVue} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';

import i18n from '@/libs/i18n';
import router from './router';
import store from './store';
import App from './App.vue';

import mdiVue from 'mdi-vue/v2';
import * as mdijs from '@mdi/js';

// Global Components
import './global-components';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import {getUserData} from '@/auth/utils';
import useAppConfig from '@core/app-config/useAppConfig';

// 3rd party plugins
import '@axios';
import '@/libs/portal-vue';
import '@/libs/toastification';
import '@/libs/sweet-alerts';
import '@/libs/vue-select';
import {required, email} from '@validations'; // It's important things

Ripple.color = 'rgba(255, 255, 255, 0.15)';

Vue.directive('ripple', Ripple);

Vue.use(mdiVue, {
    icons: mdijs,
});

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);

// Composition API
Vue.use(VueCompositionAPI);

Vue.use(i18n);

const {currentUser} = useAppConfig();

// Global Mixin
Vue.mixin({
    data() {
        return {
            userData: getUserData(),
        };
    },
    computed: {
        swedishLang() {
            return this.defaultLang == 'sv';
        },
        defaultLang() {
            return localStorage.getItem('lang');
        },
    },
    methods: {
        popupMsg(title, text, icon, variant) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    timeout: 1500,
                    title: title,
                    text: text,
                    icon: icon,
                    variant: variant,
                },
            });
        },
        updateMyAccount() {
            useJwt.getMyAccount().then(res => {
                currentUser.value = res.data.data;
            });
        },
    },
});

// import core styles
require('@core/scss/core.scss');

// import assets styles
require('@/assets/scss/style.scss');

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app');
